<template>
	<div>
		<div
			class="modal fade"
			id="sellerPopUp"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>

					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Seller</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "resetAction();">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div class="spinner-border" v-if="isLoading" style="margin:auto;display:block"/>
						<div v-else>
							<SellerData
								ref="seller"
								:seller = "seller"
								:countryList = "countryList"
								:sellerList = "sellerList"
								:disableMechantName = "disableMechantName"
							/>
						</div>

					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<!-- <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "resetAction()">Cancel</button> -->
							<button type="button" class="btn btn-primary" @click = "saveSeller()">Save</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import Multiselect from "vue-multiselect";
import moment from "moment";
import SellerData from "./SellerData.vue";

export default {
	name: "SellerPopUp",
	components:{Multiselect, moment, SellerData},
	props:["sellerList", "index"],
	data(){
		return{
			seller: {
				id:"",
				merchant_id:"",
				merchant_type:"",
				country_code:null,
				marketplace_id:"",
				marketplace_url:"",
				access_key_id:"",
				secret_access_key:"",
				seller_dev_auth_token:null,
				vendor:null,
				merchant_name:null,
				merchant_new:""
			},
			vendorList:[],
			isEdit:false,
			isVendorSellerLoading:false,
			submitted:false,
			countryList:[],
			disableMechantName:false,
			isLoading:false
		}
	},
	watch:{
	},
	computed: {

	},
	mounted(){
		 this.getCountryList();
	},
	methods:{
		getCountryList(){
			let vm = this;
			this.$store.dispatch("accounts/getCountryList").then((res) => {
				vm.countryList = res;
				let data = vm.countryList.find((e) => e.market_place == 'US')
				let index = vm.countryList.indexOf(data)
				vm.countryList.splice(index, 1)
				vm.countryList.unshift(data)

			})
		},
		resetData(){
			this.seller = {};
			this.vendorList = [];
			this.isEdit = false;
			this.isVendorSellerLoading = false;
			this.submitted = false;
			//this.countryList = [];
			this.disableMechantName = false
		},
		saveSeller(){
			let vm = this;
			this.submitted = true
			if(this.validate()){
				this.isLoading = true

				this.$store.dispatch("accounts/saveEditSeller", this.seller).then((res) => {
					vm.seller.merchant_new = ''
					if(res.length){
						vm.$emit('updateSellerList', res[0], vm.index)
						vm.isLoading = false
						vm.resetData()
						vm.resetAction()
						
						
					}
					else{
						this.$refs['seller'].resetValue(true)
					}
				})
			}
		},
		validate(){
			let checkDuplicate = this.$refs['seller'].alreadyExistName || this.$refs['seller'].alreadyExistId;
			
			if(!this.seller.merchant_id || checkDuplicate || !this.seller.merchant_name.merchant_name || !this.seller.country_code){
				 this.$refs['seller'].validate(true)
				return false
			}
			else{
				this.$refs['seller'].validate(false)
				return true
			}
		},
		resetAction(){
			this.$refs['seller'].validate(false)
			this.$refs['seller'].resetValue(false)
			this.seller.merchant_new = ''
		//	this.seller.merchant_name = this.seller &&  this.seller.merchant_name ? this.seller.merchant_name.merchant_name : null
			this.$emit('updateAddedCancelSellerInfo', this.seller, this.sellerActionType, this.index)
			this.resetData()
		}
	}
}

</script>
